import type { LabeledValuePayload } from '@Application/Users/UserStatuses/Actions/userStatusesFetched';

/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * Shared by every store built on top of the `{ value, label }` enum shape — it belongs to no single
 * domain, so it lives under `Store/Shared/` rather than duplicated per store.
 */
class LabeledValueView {
	readonly value: string;
	readonly label: string;

	constructor(payload: LabeledValuePayload) {
		this.value = payload.value;
		this.label = payload.label;

		Object.freeze(this);
	}
}

export default LabeledValueView;
